<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showTrustLevelModal"
                   :data="model"
                   :title="$t('Bidding Limit')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>

      <input-widget :model="model" attribute="disable_auto_promotion" type="checkbox"
                    :is-switch="true"/>

      <input-widget type="select2" :model="model" attribute="trust_level_uuid" :items="trustLevels"
                    display-field="${item.name}"
                    value-field="value"
                    @select2Select="onSelect"/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CustomerTrustLevelModel from "../../../models/CustomerTrustLevelForm.model";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget.vue";
  import {Formatter} from "../../../../../core/services/formatter.service";
  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "CustomerTrustLevelModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new CustomerTrustLevelModel({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleTrustLevelModal', 'createCustomerTrustLevel', 'updateCustomerTrustLevel']),
      async onSubmit() {
        this.loading = true;
        const data = {
          trust_level_uuid: this.model.trust_level_uuid,
          customer_uuid: this.customer.uuid,
          branch_uuid: this.currentBranch.uuid,
          disable_auto_promotion: this.model.disable_auto_promotion
        };
        let response;
        if (this.model.uuid) {
          data.uuid = this.model.uuid;
          response = await this.updateCustomerTrustLevel(data);
        } else {
          response = await this.createCustomerTrustLevel(data);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleTrustLevelModal(false);
          this.$toast('success', this.$t('Trust Level Tier was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
        this.model = new CustomerTrustLevelModel(this.trust_level);
      },
      onHidden() {
        this.model = new CustomerTrustLevelModel();
        this.toggleTrustLevelModal(false);
      },
      onSelect(data) {
        if (!this.trust_level) {
          return;
        }
        const customerTrustLevel = this.trustLevels.find(tr => tr.uuid === this.trust_level.trust_level_uuid);
        console.log(customerTrustLevel);
        if (customerTrustLevel && customerTrustLevel.credit_limit && customerTrustLevel.credit_limit > data.credit_limit) {
          this.model.disable_auto_promotion = true;
        }
      }
    },
    computed: {
      ...globalMapState({
        currentBranch: state => state.currentBranch,
        trustLevels: state => state.currentBranch.trust_levels ? state.currentBranch.trust_levels.sort((a,b) => {
          if (a.credit_limit > b.credit_limit) {
            return 1;
          } else if (b.credit_limit > a.credit_limit) {
            return -1;
          }
          return 0;
        }).map((trustLevel) => {
          return {
            uuid: trustLevel.uuid,
            name: `${trustLevel.name} | Limit(${Formatter.asCurrency(trustLevel.credit_limit)}) | Threshold(${Formatter.asCurrency(trustLevel.threshold)})`,
            value: trustLevel.uuid,
            exclude_from_auto_assignment: trustLevel.exclude_from_auto_assignment,
            credit_limit: trustLevel.credit_limit
          }
        }) : []
      }),
      ...mapState({
        showTrustLevelModal: state => state.termsData.showTrustLevelModal,
        trust_level: state => state.customer.trust_level,
        customer: state => state.customer
      }),
    }
  }
</script>

<style scoped>

</style>